import React, { Component, useEffect } from 'react'
import { connect } from 'react-redux'
import { isEmpty, pathOr } from 'ramda'
import { Popover, Spinner, Position, Dialog } from '@blueprintjs/core'
import { localizedDateFormatter, getUserTimeZone, localizedTranslate, parseTimeZone } from 'assets/localization'
import moment from 'moment'
import Button from 'components/controls/button'
import 'less/scheduler/event-popover.less'
import Storage from 'shared/helpers/storage'
import { timezoneAbbreviationLabel } from 'shared/helpers/user'
import invalidateIcon from 'assets/icons/invalidateIcon.png'
import rescheduleIcon from 'assets/icons/rescheduleIcon.png'
import rescheduleDisabledIcon from 'assets/icons/rescheduleDisabledIcon.png'
import InvalidateInterviewModal from "containers/interviews/invalidate-interview-modal";
import { sendSingle as sendSingleSessionReschedule } from 'store/editSession/editSessionActions'
import {
  ModalFooterControls,
  ModalHeaderControls,
} from "shared/helpers/modal-controls";
import "less/scheduler/timeslot-management-modal.less";
import EditSessionView from "containers/scheduler/timeslot-management-modal/edit-session";


const Moderator = props => {
  useEffect(() => {
    props.getSessionLink(props.timeSlotId)
  },[props?.moderator?.label])

  return (
  <div className={`moderator ${props.isCurrentUser ? 'current-moderator' : ''} ${props.moderator.isHost ? 'host-moderator' : ''}`}>
    {props.moderator.isHost ? <img src="/stylesheets/Qual-Scheduler/host_icon.svg" alt="Host" /> : <i className="im-user2" />}
    <span className="moderator-detail"><b>Moderator:</b> {props.moderator.label}</span>
    {
      props.isCurrentUser &&
      !(props.event && props.event.isInvalidatedInterview) && (
        <a
          className="join-session-link"
          target="_blank"
          rel="noopener noreferrer"
          href={props.conferenceLink}
        >
          <i className="im-ss-upright" />JOIN SESSION
        </a>
      )
    }
  </div>
  )
}

const renderEventModerators = props =>
  <div className="moderators-list">
    {props.isLoading ? <Spinner intent="primary" /> : props.currentModerators.map(moderator =>
      <Moderator
        key={moderator.moderatorId}
        moderator={props.possibleModeratorsById[moderator.moderatorId]}
        isCurrentUser={props.currentUserId === moderator.moderatorId}
        {...props}
      />
    )}
  </div>

const renderAvailabilityText = () => 'During this time you are able to take interviews from any applicable Apollo Qual Scheduler Projects.'

const PopoverContent = ({
  event,
  formatDate,
  timeZone,
  closePopover,
  eventHeader,
  eventSubHeader,
  renderEventBody,
  eventIsTimeSlot,
  footerAction,
  footerText,
  availabilityBelongstoCurrentUser,
  colorCode,
  isPMOrAdmin,
  isModeratorManagement,
  importAvStatus,
  canNotRunImport,
  externalCalendar,
  openInvalidateModal,
  openRescheduleModal,
  ...props
}) => <div className="popover-content">
    <div className={`popover-header ${colorCode} ${eventIsTimeSlot ? '' : 'availability-popover'} ${event.isInvalidatedInterview ? 'invalidated' : ''}`}>
      <div className="popover-header-text">
        <strong>{eventHeader}</strong>
        <i className="im-close2" onClick={closePopover} />
      </div>
      <span className="popover-sub-header-text">{eventSubHeader}</span>
    </div>
    <div className="interview-details">
      <i className="im-ss-clock" />
      <div className="details">
        <span className="interview-date">{`${formatDate(event.startTime, 'ddd MMM. DD, YYYY')}`}</span>
        <span className="interview-time">{
          `${formatDate(event.startTime, 'h:mm A')} - ${formatDate(event.endTime, 'h:mm A')} ${
            timezoneAbbreviationLabel(timeZone)
          }`
        }</span>
      </div>
    </div>
    <div className={`popover-body ${eventIsTimeSlot ? '' : 'availability-popover'}`}>
      {renderEventBody({event, ...props})}
    </div>
    { !event.isImported ? 
      moment.tz(event.endTime, timeZone).isBefore() && (event.paymentStatus === 0 || event.paymentStatus === '0') ?
        !event.isInvalidatedInterview ?
          isModeratorManagement && <Button
            className={"popover-footer invalidate-icon"}
            onClick={() => {
              openInvalidateModal()
            }}
          >
            <img src={invalidateIcon} alt="Home" />
            <div className={'invalidate-text'}>INVALIDATE THIS INTERVIEW</div>
          </Button>
          :
          event.isInvalidatedInterview && event.isInvalidateEmailSent ? <Button
            className={"popover-footer invalidate-icon"}
            onClick={footerAction}
            disabled={true}
          >
            <img src={rescheduleDisabledIcon} alt="Home" />
            <div className={'invalidate-text'}>INTERVIEW ALREADY RESCHEDULED</div>
          </Button> :
            event.isInvalidatedInterview && !event.isInvalidateEmailSent ?
              <Button
                className={"popover-footer invalidate-icon"}
                onClick={() => openRescheduleModal()}
                disabled={!isModeratorManagement}
              >
                <img src={rescheduleIcon} alt="Home" />
                <div className={'invalidate-text'}>RESCHEDULE INTERVIEW</div>
              </Button> : ''
        :
        ((!isPMOrAdmin && (eventIsTimeSlot || availabilityBelongstoCurrentUser)) || (isPMOrAdmin &&isModeratorManagement)) && footerText &&
        <Button
        className={"popover-footer"}
        onClick={footerAction}
        disabled={moment.tz(event.endTime, timeZone).isBefore() || (!eventIsTimeSlot && (isPMOrAdmin && !isModeratorManagement)) || (importAvStatus === "In Progress")} 
      >
        <i className={(importAvStatus === 'In Progress') ? 'im-ss-loading' : eventIsTimeSlot ? 'im-edit' : 'im-trash'} />
        <span className={(importAvStatus === 'In Progress') ? 'in-progress' : ''}>{footerText}</span>
      </Button>
      :
      <Button
      className={"popover-footer"}
      onClick={()=> window.open(externalCalendar)}
      disabled={moment.tz(event.endTime, timeZone).isBefore() || (!eventIsTimeSlot && (isPMOrAdmin && !isModeratorManagement)) } 
    >
      <i className='im-ss-redirect' />
      <span className='view-spreadsheet-link'>{"VIEW EXTERNAL AVAILIBILITY LINK"}</span>
    </Button>
    }
  </div>


class EventComponent extends Component {
  state = {
    showInvalidateModal: false,
    showRescheduleModal: false,
    fromInvalidateModal: false,
    invalidateFormState: null,
    suppressPopover: false,
  }

  openInvalidateModal = () => {
    if (this.props.forceClosePopover) {
      this.props.forceClosePopover()
    }
    this.setState({
      showInvalidateModal: true,
      suppressPopover: true,
      invalidateFormState: null,
    });
  }

  closeInvalidateModal = () => {
    this.props.forceClosePopover();
    this.setState({ showInvalidateModal: false })
  }

  openRescheduleModal = () => {
    if (this.props.forceClosePopover) {
      this.props.forceClosePopover()
    }
    this.setState({ showRescheduleModal: true, suppressPopover: true });
  }

  getPopOverPosition = () => {
    const wednesday = 3
    return moment.tz(this.props.event.startTime, this.props.userTimeZone).day() > wednesday ?
      Position.LEFT : Position.RIGHT
  }

  render () {
    const { showInvalidateModal, showRescheduleModal } = this.state
    const {
      event,
      formatDate,
      userTimeZone,
      footerAction,
      togglePopOver,
      stateToPullFrom,
      isModeratorManagement,
      t,
    } = this.props
    const isPMOrAdmin =  this.props.user.userRole === 2 || this.props.user.userRole === 3
    const colorCode = isPMOrAdmin && !isModeratorManagement?  pathOr('lavender-purple', [event.moderatorId, 'className'], this.props.state.scheduler.moderatorColorsById) : 'lavender-purple'
    const isOpen = stateToPullFrom.isOpen && stateToPullFrom.selectedEventId === event.virtualId
    const isModalOpen = showInvalidateModal || showRescheduleModal
    const closePopover = () => {
      if (!isModalOpen) {
        this.props.forceClosePopover();
      }
    };
    const popoverIsOpen =
      !isModalOpen &&
      !this.props.isLoading &&
      !this.state.suppressPopover &&
      isOpen;
    const projectName = pathOr('Interview', ['projectName'], event)
    const externalSurveyId = pathOr('', ['externalSurveyId'], event)
    const participantId = pathOr('', ['intervieweeId'], event)
    const startTime = pathOr(event.startTime, ['startTime'], event)
    const endTime = pathOr(event.endTime, ['endTime'], event)
    const moderatorLabel = pathOr('', ['moderatorLabel'], event)
    const firstName = pathOr('', ['moderatorFirstName'], event) || pathOr('', ['firstName'], event)
    const lastName = pathOr('', ['moderatorLastName'], event) || pathOr('', ['lastName'], event)
    const fallbackModeratorName = [firstName, lastName].filter(Boolean).join(' ')
    const possibleModeratorsById = pathOr({}, ['possibleModeratorsById'], stateToPullFrom)
    const derivedModeratorNames = pathOr([], ['moderators'], stateToPullFrom)
      .map(({ moderatorId }) => pathOr('', [moderatorId, 'label'], possibleModeratorsById))
      .filter(Boolean)
    const schedulerState = pathOr({}, ['scheduler'], this.props.state)
    const fallbackModeratorId = pathOr('', ['singleModerator', 'id'], schedulerState)
    const fallbackClientId = pathOr('', ['singleModerator', 'clientId'], schedulerState)
    const globalClientId = pathOr('', ['client', 'clientId'], this.props.state)
    const moderatorId = pathOr(fallbackModeratorId, ['moderatorId'], event)
    const clientId = pathOr(fallbackClientId || globalClientId, ['clientId'], event)
    const moderatorName = (moderatorLabel || fallbackModeratorName || derivedModeratorNames.join(', ')).trim()
    const projectDisplayName = `${projectName}${externalSurveyId ? ` #${externalSurveyId}` : ''}`

    const portalContainer = (typeof document !== 'undefined') && (
    document.querySelector('.rbc-time-content') ||
    document.querySelector('.rbc-month-view') ||
    document.querySelector('.rbc-calendar') ||
    document.body
   )

    return (
      <React.Fragment>
        {showInvalidateModal && (
          <InvalidateInterviewModal
            isOpen={showInvalidateModal}
            origin={"interviews"}
            onClose={this.closeInvalidateModal}
            initialReschedule={this.state.invalidateFormState?.reschedule}
            initialReason={this.state.invalidateFormState?.reason}
            initialOtherReason={this.state.invalidateFormState?.otherReason}
            onConfirm={({ action, reason, otherReason }) => {
              const timeSlotId =
                this.props.event.timeSlotId || this.props.event.timeslotId;
              const invalidateSelected = {
                reason,
                otherReason:
                  reason === "other" && typeof otherReason === "string"
                    ? otherReason.trim()
                    : undefined,
              };
              const payload = {
                action: "reschedule",
                projectId: this.props.event.projectId,
                timeSlotId,
                isInvalidateEmailSent: false,
                invalidateSelected,
                projectName: projectName,
                participantId: participantId,
                moderatorId: moderatorId,
                clientId: clientId,
                isModeratorManagement: true,
                invalidateReschedule: true,
              };
              if (action === "invalidate_no_reschedule") {
                this.props.sendSingleReschedule({
                  ...payload,
                  isInvalidateEmailSent: false,
                });
              } else if (action === "invalidate_and_reschedule") {
                this.props.forceClosePopover();
                this.setState({
                  showInvalidateModal: false,
                  showRescheduleModal: true,
                  fromInvalidateModal: true,
                  invalidateFormState: {
                    reschedule: true,
                    reason,
                    otherReason,
                  },
                });
              }
            }}
            projectName={projectDisplayName}
            participantId={participantId}
            startTime={startTime}
            endTime={endTime}
            timeZone={userTimeZone}
            formatDate={formatDate}
            moderatorName={moderatorName}
            t={t}
          />
        )}
        {showRescheduleModal && (
          <Dialog
            className="timeslot-management-modal"
            isOpen={showRescheduleModal}
            onClose={() => {
              this.props.forceClosePopover();
              this.setState({ showRescheduleModal: false });
            }}
          >
            <ModalHeaderControls
              firstStep
              currentStep={""}
              fromInvalid={true}
              toggleModal={() => this.setState({ showRescheduleModal: false })}
              innerComponent={
                <h4 className="bp3-dialog-header-title">
                  Reschedule Interview
                </h4>
              }
              hideBackButton={this.state.fromInvalidateModal ? false : true}
              back={() => {
                this.setState({
                  showRescheduleModal: false,
                  showInvalidateModal: true,
                  suppressPopover: true,
                });
              }}
            />
            <EditSessionView
              chosenAction={"reschedule"}
              interviewDateTime={`${formatDate(
                startTime,
                "dddd, MMMM DD, YYYY",
              )} @ ${formatDate(
                startTime,
                "h:mm A",
              )} ${parseTimeZone(userTimeZone)}`}
              {...this.props}
            />
            <div className="bp3-dialog-footer">
              <ModalFooterControls
                finalStep
                finalStepLabel={"Confirm & Send"}
                finalStepFn={() => {
                  this.props.forceClosePopover();
                  if (this.state.fromInvalidateModal) {
                    const { reason, otherReason } = this.state.invalidateFormState || {};
                    this.setState({ showRescheduleModal: false });
                    this.props.sendSingleReschedule({
                      action: "reschedule",
                      invalidateReschedule: true,
                      isInvalidateEmailSent: true,
                      projectId: this.props.event.projectId,
                      timeSlotId:
                        this.props.event.timeSlotId ||
                        this.props.event.timeslotId,
                      moderatorId,
                      clientId,
                      isModeratorManagement: true,
                      invalidateSelected: {
                        reason,
                        otherReason:
                          reason === "other" && typeof otherReason === "string"
                            ? otherReason.trim()
                            : undefined,
                      },
                    });
                    this.setState({ invalidateFormState: null });
                    this.setState({ fromInvalidateModal: false });
                  } else {
                    this.setState({ showRescheduleModal: false });
                    this.props.sendSingleReschedule({
                      action: "reschedule",
                      invalidateReschedule: true,
                      isInvalidateEmailSent: false,
                      hideBackButton: true,
                      projectId: this.props.event.projectId,
                      timeSlotId:
                        this.props.event.timeSlotId ||
                        this.props.event.timeslotId,
                      moderatorId: moderatorId,
                      clientId: clientId,
                      isModeratorManagement: true,
                    });
                  }
                }}
                toggleModal={() =>
                  this.setState({ showRescheduleModal: false })
                }
              />
            </div>
          </Dialog>
        )}
        <Popover
          isOpen={popoverIsOpen}
          onClose={closePopover}
          position={this.getPopOverPosition()}
          usePortal={true}
          portalContainer={portalContainer}
        >
          <div
            onClick={() => {
              if (this.state.suppressPopover) {
                this.setState({ suppressPopover: false });
              }
            }}
          >
            <div className="event-time-header">{`${formatDate(event.startTime, "h:mm A")} - ${formatDate(event.endTime, "h:mm A")} ${timezoneAbbreviationLabel(userTimeZone)}`}</div>
            <strong>
              {`${stateToPullFrom.previewText || stateToPullFrom.eventHeader}` +
                `${event.isInvalidatedInterview ? " (Invalidated)" : ""}`}
            </strong>
            {event.isImported && (
              <div className="imported-availability-label">
                Imported Availability
              </div>
            )}
          </div>
          <PopoverContent
            event={event}
            formatDate={formatDate}
            timeZone={userTimeZone}
            currentModerators={stateToPullFrom.moderators}
            closePopover={closePopover}
            possibleModeratorsById={stateToPullFrom.possibleModeratorsById}
            currentUserId={stateToPullFrom.currentUserId}
            isLoading={stateToPullFrom.isLoading}
            eventHeader={event.isInvalidatedInterview ? stateToPullFrom.eventHeader + " (Invalidated)" : stateToPullFrom.eventHeader}
            eventSubHeader={stateToPullFrom.eventSubHeader}
            renderEventBody={
              stateToPullFrom.eventIsTimeSlot
                ? renderEventModerators
                : renderAvailabilityText
            }
            eventIsTimeSlot={stateToPullFrom.eventIsTimeSlot}
            footerAction={footerAction}
            footerText={stateToPullFrom.footerText}
            availabilityBelongstoCurrentUser={
              stateToPullFrom.availabilityBelongstoCurrentUser
            }
            projectId={this.props.event.projectId}
            timeSlotId={this.props.event.timeslotId}
            getSessionLink={this.props.fetchConferenceLinkByTimeslotId}
            conferenceLink={stateToPullFrom.conferenceLink}
            colorCode={event.isImported ? "light-green" : colorCode}
            isPMOrAdmin={isPMOrAdmin}
            isModeratorManagement={isModeratorManagement}
            importAvStatus={this.props.importAvStatus}
            externalCalendar={this.props.externalCalendar}
            canNotRunImport={this.props.canNotRunImport}
            openInvalidateModal={this.openInvalidateModal}
            openRescheduleModal={this.openRescheduleModal}
          />
        </Popover>
      </React.Fragment>
    );
  }
}

const mapState = (state, {event}) => {
  const onMySchedule = isEmpty(state.currentProject)
  /*const moderatorInfo = onMySchedule ? state.user.userInfo :
  state.currentProject.users.find(propEq('id', event.moderatorId))
  */
  const currentUserId = state.user.userId
  const isModeratorManagement = window.location.href.indexOf("moderatorManagement") > -1
  const isAllModeratorsCalendar = window.location.href.indexOf("/moderator/schedule") > -1
  const userTimeZone = isModeratorManagement? state.scheduler.selectedTimeZone : getUserTimeZone(state)
  return {
    formatDate: localizedDateFormatter('en', userTimeZone),
    userTimeZone: userTimeZone,
    event,
    isModeratorManagement: isModeratorManagement,
    user: state.user,
    stateToPullFrom: event.eventType === 'timeSlot' ? {
      selectedEventId: state.scheduler.selectedVirtualId,
      isOpen: state.scheduler.timeSlotPopOverisOpen && state.scheduler.selectedSlotId === event.timeSlotId,
      eventHeader: pathOr('Interview', ['projectName'], event),
      footerText: ( state.scheduler.importAvStatus === "In Progress") ? 'Update In-Progress' : isAllModeratorsCalendar ? null : 'EDIT & MANAGE THIS INTERVIEW',
      eventSubHeader: 
        <div>
          <div>{event.topicName}</div>
          <div>PARTICIPANT ID: #{event.intervieweeId}</div>
        </div>,
      eventIsTimeSlot: true,
      possibleModeratorsById: state.scheduler.possibleModeratorsById,
      moderators: state.scheduler.moderatorTimeSlots,
      currentUserId,
      isLoading: state.scheduler.isLoading,
      conferenceLink: state.scheduler.conferenceLink,
    } : {
      selectedEventId: state.scheduler.selectedVirtualId,
      isOpen: state.scheduler.availabilityPopOverisOpen && state.scheduler.selectedAvailabilityId === event.id,
      eventHeader: 'Availability Timeslot',
      previewText: `${event.firstName? event.firstName : Storage.getItem('firstName')} ${event.lastName? event.lastName : Storage.getItem('lastName')}`,
      footerText:  (state.scheduler.importAvStatus === "In Progress") ? 'UPDATE IN-PROGRESS' :'DELETE AVAILABILITY',
      eventSubHeader: `${event.firstName? event.firstName : Storage.getItem('firstName')} ${event.lastName? event.lastName : Storage.getItem('lastName')}`,
      availabilityBelongstoCurrentUser: event.moderatorId === currentUserId,
    },
    state : state,
    importAvStatus: state.scheduler.importAvStatus,
    canNotRunImport: state.scheduler.canNotRunImport,
    externalCalendar: state.scheduler.externalCalendar,
    isLoading: pathOr(false, ['editSession', 'isSubmitting'], state),
    t: localizedTranslate('en', state.translations.en_us),
  }
}

const mapDispatch = (dispatch, {event}) => ({
  footerAction: event.eventType === 'timeSlot' && event.importedOverLap === "0" ?
    () => dispatch({type: 'TOGGLE_TIMESLOT_MODAL' }) : 
    event.eventType === 'timeSlot' && event.importedOverLap === "1" ? 
    () => dispatch({type: 'TOGGLE_IMP_AVA_WARNING_MODAL' }) :
    () => dispatch({type: 'DELETE_MODERATOR_AVAILABILITY_REQUESTED', payload: event.availabilityId }),
  togglePopOver: payload => dispatch({
    type: event.eventType === 'timeSlot' ? 'TOGGLE_TIMESLOT_POPOVER' : 'TOGGLE_AVAILABILITY_POPOVER',
    payload,
  }),
  fetchConferenceLinkByTimeslotId : payload => dispatch({type: 'FETCH_CONFERENCE_LINK_BY_TIMESLOT_REQUESTED', payload }),
  sendSingleReschedule: payload => dispatch(sendSingleSessionReschedule(payload)),
  forceClosePopover: () => {
    if (event.eventType === 'timeSlot') {
      dispatch({ type: 'CLOSE_TIMESLOT_POPOVER' })
    }
    // Deferred close ensures popover is closed after BlueprintJS internal click/focus handlers and Redux batched updates
    setTimeout(() => {
      dispatch({ type: 'CLOSE_TIMESLOT_POPOVER' });
    }, 0);
  }
})

export default connect(mapState, mapDispatch)(EventComponent)